export default {"src":"/_next/static/image/public/images/No_available_report.a0a6d7fccf134fd7a93e4b096de3ca1f.svg","height":153,"width":162};